import { render, staticRenderFns } from "./ManageAccounts.vue?vue&type=template&id=48645e6c"
import script from "./ManageAccounts.vue?vue&type=script&lang=js"
export * from "./ManageAccounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports